<template>
  <footer id="footer" class="footer">
    <!--  notes: v-lazyload, checkIfResultsPage on what div for mobile search, OPEN NOW beside phone number needs more space for when it says OPEN AT 10:00 AM, what is the url for the sitemap?-->
    <section class="footer__top">
      <div class="footer__contact">
        <div class="callback">
          <a class="callback__button btn-primary-light-sm text-dark" style="max-width: fit-content;" href="https://bookings.thethinkingtraveller.com/portal-embed#/customer/callbacks" target="_blank">
            Book an initial call
          </a>
        </div>
      </div>
      <div class="footer__lang">
        <div class="selectors">
          <language-selector class="langSelector" theme="dark" />
          <currency-selector class="currencySelector" theme="dark" />
        </div>
      </div>
    </section>

    <div class="footer__borders">
      <section class="footer__main">
        <div class="footer__main--marketing">
          <div class="footer__signup">
            <div class="footer__signup--text">
              <p class="h1">
                Your keys to our house
              </p>
              <p>Sign up to our newsletter for beautiful villas, destinations, and things to do</p>
            </div>
            <!-- <form>
              <input id="su-email" ref="emailInput" v-model="userEmail" type="email" name="email" tabindex="0" placeholder="Email address" aria-label="Email address">
              <button tabindex="0" class="btn btn-white-border text-light sign-up" @click="navigateToNewsletterSignup">
                Sign Up
              </button>
            </form> -->

            <form tabindex="0" class="signupInput__form" @submit.prevent>
              <input
                id="su-email"
                ref="emailInput"
                v-model="userEmail"
                type="email"
                name="email"
                tabindex="0"
                placeholder="Enter email address"
                aria-label="Email address"
              >
              <button @click="navigateToNewsletterSignup">
                <img src="../assets/img/src/icons/curved-arrow-right.svg" alt="Arrow Right" class="signupInput__icon lazyload">
              </button>
            </form>
          </div>
          <div class="footer__socials">
            <div class="footer__socials--icons">
              <a href="https://www.youtube.com/c/thethinkingtraveller" target="_blank" aria-label="Youtube">
                <font-awesome-icon :icon="['fab', 'youtube']" size="2xl" style="color: #FEFCFA" class="link-unstyle" />
              </a>
              <a href="https://www.facebook.com/TheThinkingTraveller" target="_blank" aria-label="Facebook">
                <font-awesome-icon :icon="['fab', 'facebook']" size="2xl" style="color: #FEFCFA" class="link-unstyle" />
              </a>
              <a href="https://www.instagram.com/thethinkingtraveller/" target="_blank" aria-label="Instagram">
                <font-awesome-icon :icon="['fab', 'instagram']" size="2xl" style="color: #FEFCFA" class="link-unstyle" />
              </a>
              <a href="https://open.spotify.com/user/kv2i82qr0ssk4t21isqqn3brx" target="_blank" aria-label="Spotify">
                <font-awesome-icon :icon="['fab', 'spotify']" size="2xl" style="color: #FEFCFA" class="link-unstyle" />
              </a>
            </div>
          </div>
        </div>
        <div class="footer__main--links">
          <div>
            <!-- OUR DESTINATIONS -->
            <ul v-if="isDesktop" style="margin-bottom: 3em;">
              <li class="footer__main--links_title semi-bold">
                Our Destinations
              </li>
              <li>
                <app-link id="1087" type="page">
                  Greece
                </app-link>
              </li>
              <li>
                <app-link id="26" type="page">
                  Sicily
                </app-link>
              </li>
              <li>
                <app-link id="28" type="page">
                  Puglia
                </app-link>
              </li>
              <!-- <li>
                <app-link id="835" type="page">
                  Tuscan Islands
                </app-link>
              </li> -->
              <li>
                <app-link id="30" type="page">
                  Corsica
                </app-link>
              </li>
              <!-- <li>
                <app-link id="943" type="page">
                  Mallorca
                </app-link>
              </li> -->
              <li @click="clearDestinations">
                <app-link id="16" type="page">
                  All destinations
                </app-link>
              </li>
            </ul>

            <!-- BOOKING YOUR VILLA -->
            <ul v-if="isDesktop" class="footer__column">
              <li class="footer__main--links_title semi-bold semi-bold">
                Booking your villa
              </li>
              <li>
                <app-link id="44" type="page">
                  How to book
                </app-link>
              </li>
              <li>
                <app-link id="79" type="page">
                  Log in to My Account
                </app-link>
              </li>
              <li>
                <app-link id="74" type="page">
                  Booking conditions
                </app-link>
              </li>
              <li>
                <app-link id="46" type="page">
                  Contact us
                </app-link>
              </li>
              <li>
                <app-link id="49" type="page">
                  FAQ
                </app-link>
              </li>
            </ul>
          </div>

          <!-- OUR DETAILS - LONDON -->
          <ul v-if="isDesktop" class="footer__column">
            <li class="footer__main--links_title semi-bold semi-bold">
              London
            </li>
            <li style="margin-bottom: 2em;">
              The Old Truman Brewery<br>
              91-95 Brick Lane<br>
              London E1 6QL<br>
              United Kingdom<br>
              <a :href="`tel:${officePhoneNumber}`" class="InfinityNumber clickable track-gtm-contact-phone footer-row-2">{{ officePhoneNumber }}</a><br>
              <!-- <small class="footer__link small">
                {{ this.$store.getters["common/getOfficeStatus"].officeStatus }}
              </small> -->
            </li>
            <li class="footer__main--links_title semi-bold athens semi-bold">
              Athens
            </li>
            <li>
              Ethnikis Antistaseos 73<br>
              Halandri, Athens 15231<br>
              Greece<br>
              <a href="tel:302107215530">+302107215530</a>
            </li>
          </ul>

          <!-- OUR COMPANY -->
          <ul v-if="isDesktop" class="footer__column">
            <li class="footer__main--links_title semi-bold semi-bold">
              Our Company
            </li>
            <li>
              <app-link id="1049" type="page">
                Travel Notes blog
              </app-link>
            </li>
            <li>
              <app-link id="47" type="page">
                About us
              </app-link>
            </li>
            <!-- <li>
              <app-link id="68" type="page">
                Meet the team
              </app-link>
            </li> -->
            <li>
              <app-link id="77" type="page">
                Awards
              </app-link>
            </li>
            <li>
              <app-link id="75" type="page">
                Careers
              </app-link>
            </li>
            <li>
              <app-link id="873" type="page">
                Press enquiries
              </app-link>
            </li>
            <li>
              <app-link id="922" type="page">
                Villa owners
              </app-link>
            </li>
            <li>
              <app-link id="1241" type="page">
                A responsible company
              </app-link>
            </li>
            <li>
              <app-link id="1241" type="page">
                <img src="https://www.thethinkingtraveller.com/media/Web/bcorp_cert_logo.png" alt="B Corp" style="margin-top: 3em;" width="70px">
              </app-link>
            </li>
          </ul>
        </div>
      </section>
    </div>

    <!-- TABLET/MOBILE -->
    <div v-if="!isDesktop">
      <footer-accordion heading="Our Destinations" :open="false">
        <ul class="footer__column">
          <li>
            <app-link id="1087" type="page">
              Greece
            </app-link>
          </li>
          <li>
            <app-link id="26" type="page">
              Sicily
            </app-link>
          </li>
          <li>
            <app-link id="28" type="page">
              Puglia
            </app-link>
          </li>
          <!-- <li>
            <app-link id="835" type="page">
              Tuscan Islands
            </app-link>
          </li> -->
          <li>
            <app-link id="30" type="page">
              Corsica
            </app-link>
          </li>
          <!-- <li>
            <app-link id="943" type="page">
              Mallorca
            </app-link>
          </li> -->
          <li @click="clearDestinations">
            <app-link id="16" type="page">
              All destinations
            </app-link>
          </li>
        </ul>
      </footer-accordion>

      <footer-accordion heading="Booking your villa" :open="false">
        <ul class="footer__column">
          <li>
            <app-link id="44" type="page">
              How to book
            </app-link>
          </li>
          <li>
            <app-link id="79" type="page">
              Log in to My Account
            </app-link>
          </li>
          <li>
            <app-link id="74" type="page">
              Booking conditions
            </app-link>
          </li>
          <li>
            <app-link id="46" type="page">
              Contact us
            </app-link>
          </li>
          <li>
            <app-link id="49" type="page">
              FAQ
            </app-link>
          </li>
        </ul>
      </footer-accordion>

      <footer-accordion heading="Our Company" :open="false">
        <ul class="footer__column">
          <li>
            <app-link id="1049" type="page">
              Travel Notes blog
            </app-link>
          </li>
          <li>
            <app-link id="47" type="page">
              About us
            </app-link>
          </li>
          <!-- <li>
            <app-link id="68" type="page">
              Meet the team
            </app-link>
          </li> -->
          <li>
            <app-link id="77" type="page">
              Awards
            </app-link>
          </li>
          <li>
            <app-link id="75" type="page">
              Careers
            </app-link>
          </li>
          <li>
            <app-link id="873" type="page">
              Press enquiries
            </app-link>
          </li>
          <li>
            <app-link id="922" type="page">
              Villa owners
            </app-link>
          </li>
          <li>
            <app-link id="1241" type="page">
              A responsible company
            </app-link>
          </li>
        </ul>
      </footer-accordion>

      <footer-accordion heading="Our details" :open="false">
        <ul class="footer__column">
          <li class="footer__main--links_title semi-bold semi-bold">
            London
          </li>
          <li>
            The Old Truman Brewery<br>
            91-95 Brick Lane<br>
            London E1 6QL<br>
            United Kingdom<br>
            <a :href="`tel:${officePhoneNumber}`" class="InfinityNumber clickable track-gtm-contact-phone footer-row-2">{{ officePhoneNumber }}</a> -
            <!-- <span class="footer__link small uppercase">
              {{ this.$store.getters["common/getOfficeStatus"].officeStatus }}
            </span> -->
          </li>
          <br>
          <li class="footer__main--links_title semi-bold athens semi-bold">
            Athens
          </li>
          <li>
            Ethnikis Antistaseos 73<br>
            Halandri, Athens 15231<br>
            Greece <br>
            <a href="tel:302107215530">+302107215530</a>
          </li>
          <!-- <span class="footer__link small uppercase">
            {{ this.$store.getters["common/getOfficeStatus"].officeStatus }}
          </span> -->
        </ul>
      </footer-accordion>
    </div>

    <section class="footer__end">
      <div v-if="!isDesktop" class="B-Corp">
        <app-link id="1241" type="page">
          <img src="https://www.thethinkingtraveller.com/media/Web/bcorp_cert_logo.png" alt="B Corp" width="70px">
        </app-link>
      </div>
      <div class="trust-pilot">
        <TrustPilotReviews :darkText="false" />
      </div>
      <ul>
        <li>
          <app-link id="76" type="page">
            Privacy & Conditions
          </app-link>
        </li>
        <li>
          <app-link id="104" type="page">
            Terms of use
          </app-link>
        </li>
        <li>
          <app-link id="872" type="page">
            Cookie policy
          </app-link>
        </li>
        <li><a href="https://www.thethinkingtraveller.com/sitemaps/sitemap_index.xml">Site map</a></li>
        <li class="company-copyright">
          Company Reg No: 04421653
        </li>
        <li>
          Copyright &copy; 2002 - {{ currentYear }}
        </li>

        <!-- do not remove this hidden link - it is here so that crawlers/spiders can find villa pages -->
        <li class="hide">
          <app-link id="1236" type="page">
            All villas
          </app-link>
        </li>
      </ul>
    </section>

    <modal v-show="isModalVisible" @close="closeModal">
      <div slot="content" class="callback__modal">
        <iframe loading="lazy" title="Book an initial call" width="100%" height="100%" src="https://bookings.thethinkingtraveller.com/portal-embed#/customer/callbacks" frameborder="0" allowfullscreen="" />
      </div>
    </modal>
  </footer>
</template>

<script>
import Bus from '../events/bus';
import infinityNumberReplace from '../mixins/infinityNumberReplace';
import responsive from '../mixins/responsive';
import FooterAccordion from './FooterAccordion.vue';
import languageSelector from './languageSelector.vue';
import CurrencySelector from './CurrencySelector.vue';
import Modal from './Modal.vue';
import TrustPilotReviews from './TrustPilotReviews.vue';

export default {
  components: {
    FooterAccordion,
    languageSelector,
    CurrencySelector,
    Modal,
    TrustPilotReviews,
  },
  mixins: [infinityNumberReplace, responsive],
  data() {
    return {
      userEmail: '',
      currentYear: new Date().getFullYear(),
      isModalVisible: false,
    };
  },
  computed: {
    isOfficeOpen() {
      return this.$store.getters['common/getOfficeStatus'].officeStatus === 'OPEN NOW';
    },
    currentPagePaths() {
      return this.$store.state.pages.currentPagePaths;
    },
    currentPath() {
      return this.$store.state.pages.currentPath;
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 5 : false;
    },
    isMobileMode() {
      return this.$store.getters['common/getScreenType'] === 'tablet' || this.$store.getters['common/getScreenType'] === 'mobile';
    },
    getBottomMargin() {
      return {
        marginBottom: this.isResultsPage && this.isMobileMode ? '60px' : '20px',
      };
    },
    officePhoneNumber() {
      return this.$store.getters['common/getOfficeStatus'].officeNumber_InfinityTrackFriendly;
    },
  },
  updated() {
    // prepend +44 to the ROW number replaced by infinity (infinity number does not include)
    const numberTag = document.querySelector('.footer-row');
    if (numberTag) {
      this.ObserveInfinityNumberTag(numberTag, true); // import infinityNumberReplace
    }

    const numberTag2 = document.querySelector('.footer-row-2');
    if (numberTag2) {
      this.ObserveInfinityNumberTag(numberTag2, true); // import infinityNumberReplace
    }
  },
  methods: {
    clearDestinations() {
      Bus.$emit('resetRegions');
    },
    navigateToNewsletterSignup(e) {
      e.preventDefault();
      let qstring = (this.userEmail.length > 0) ? qstring = `?email=${this.userEmail.replaceAll('+', '%2B')}` : '';
      $router.push({ path: this.$store.getters['applinks/getLink']('page', 936).url + qstring });
      window.scrollTo(0, 0);
      this.userEmail = '';
    },
    langChange(event) {
      Localize.setLanguage(event.target.value);
    },
    showModal(e) {
      this.isModalVisible = true;
      e.preventDefault();
      document.body.classList.add('modal-open');
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.classList.remove('modal-open');
    },
  },
};
</script>

<style lang="scss" scoped>
@import'../assets/styles/settings/config.scss' ;

.footer {
  z-index: 1;
  position: relative;
  font-size: 18px;
  background-color: $darkBlack;
  color: $stoneWhite;
  font-size: 14px;
  a, a:visited, i, li {
    color: $stoneWhite;
  }
  &__wrapper {
    max-width: 1380px;
    margin: 0 auto;
  }
  &__top {
    max-width: 1380px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3em 2em;
    @media screen and (max-width: 480px) {
      flex-direction: column;
      gap: 10px;
    }
  }

  &__lang {
    .selectors {
      height: 50px;
      display: flex;
      align-items: center;
    }
    .currencySelector {
      margin-left: 30px;
    }
  }

  &__signup {
    max-width: 527px;
    @media screen and (max-width: 1023px) {
      margin: 0 auto;
    }
    &--text {
      p.h1 {
        font-size: 48px;
        font-style: normal;
        margin: 0 0 20px;
        @media screen and (max-width: 1023px) {
          font-size: 32px;
        }
      }
      p {
      font-size: 16px;
      @media screen and (min-width: 1023px) {
          max-width: 450px;
        }
      }
    }
    form {
      margin: 2em 0 3em;
    }
  }

  &__socials {
    // text-align: center;
    // display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-gap: 1em;
    // max-width: 200px;
    // margin: 0 auto;
    &--icons {
      text-align: center;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1em;
    max-width: 200px;
      @media screen and (max-width: 1023px) {
        margin: 0 auto;
      }
    }
    &--wrapper {
      display: flex;
      align-items: center;
    }
  }

  &__borders {
    border-top: 1px solid $darkBlue;
    border-bottom: 1px solid $darkBlue;
    @media screen and (max-width: 1023px) {
      border-bottom: none;
    }
  }
  &__main {
    max-width: 1380px;
    margin: 0 auto;
    padding: 3em 2em;
    display: grid;
    grid-template-columns: 0.8fr 1fr;
    grid-gap: 4em;
    @media screen and (max-width: 1023px) {
       display: block;
       text-align: center;
       border-bottom: 1px solid $darkBlue;
    }
    &--marketing {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &--links {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 1em;
      @media screen and (max-width: 1023px) {
       display: block
      }
      ul li {
        line-height: 1.7;
      }
      &_title {
        text-transform: uppercase;
        letter-spacing: 0.7px;
        margin-bottom: 10px;
      }
    }
  }

  &__end {
    margin: 0 auto;
    padding: 4em 2em 2em;
    font-size: 12px;
    @media screen and (min-width: 1023px) {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 20px;
    }
    ul {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      @media screen and (max-width: 480px) {
        display: block;
        text-align: center;
        line-height: 2;
      }
      li {
        @media screen and (min-width: 480px) {
        margin-right: 20px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

.langSelector::v-deep {
  .lang-selected {
    color: #fff !important;
    }
}

.currencySelector::v-deep {
  .currency-selected {
    font-size: 16px;
  }
}

.trust-pilot {
  &::v-deep {
    .trustpilot {
      margin: 0 auto;
      color: $stoneWhite;
      @media screen and (max-width: 480px) {
        margin-bottom: 2em;
      }
      div {
        margin-right: 5px;
      }
      &__rating {
        color: $stoneWhite;
        &--logo {
          color: $stoneWhite;
        }
      }
    }
  }
}

.B-Corp {
  display: flex;
  justify-content: center;
  margin-bottom: 4em;

}

.signupInput {
  &__form {
    width: 100%;
    position: relative;
    height: 48px;
    input {
      width: 100%;
      background-color: $darkBlue;
      border: $darkBlue;
      color: $stoneWhite;
    }
    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px #1F212F inset;
      -webkit-text-fill-color: $white;
      caret-color: $white;
    }
  }
  &-box {
    padding-bottom: 120px;
  }
  &__icon {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}

</style>
